import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ThemeToggle from './components/ThemeToggle';
import ToastProvider from './components/ToastProvider';
import reportWebVitals from './reportWebVitals';
import { notifyOtaAppReady } from './utils/otaUpdate';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/push-sw.js').catch(() => {});
  });
}

// Confirm the (possibly OTA-updated) web bundle booted OK, so Capgo commits it instead of
// rolling back. Runs on every native launch; no-op on the web.
notifyOtaAppReady();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ToastProvider at the root so every view (authed app, marketing, auth forms) can
        surface transient feedback via useToast(). */}
    <ToastProvider>
      <App />
    </ToastProvider>
    {/* Fixed, self-contained dark-mode toggle: rendered once at the root so it floats over
        every view (authed app, marketing, auth forms) regardless of App's internal routing. */}
    <ThemeToggle />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
